/**
 * "‎₪1,250.5" / "‎$250" — בדיוק כמו Format.currency ב-hatzdaka-nedarim
 * (js/common/format.js): סימן המטבע *לפני* המספר, ובלי אפסים כפויים
 * אחרי הנקודה — מספר שלם מוצג בלי עשרוניים, מספר עם שבר מוצג עד שתי
 * ספרות, בלי איפוס. ה-LRM המוביל (U+200E) שומר על סדר הצגה אחיד
 * משמאל לימין בתוך טקסט עברי, כמו במקור.
 *
 * ⚠️ **לא formatAmount/toLocaleString עם style:'currency'.** זה
 * הפורמט הקיים של האתר (סימן *אחרי* המספר, עם שתי ספרות עשרוניות
 * תמיד), ונשאר כך בטבלת הדסקטופ, בגיליון הפעולות ובמגירת הפרטים —
 * אין סיבה לשבור מוסכמה קיימת ועקבית שם. כאן, בסכום הבולט של
 * הכרטיסים המצומצמים (HAT-1170), אחרי שתאריך ומזהה כבר קוצרו לפורמט
 * הקצר של נדרים (formatDateShort), השוואת שני צילומי מסך צד-לצד
 * העלתה שגם "המספרים" עדיין נראים שונים — וזה בדיוק ההבדל.
 */
export const formatCurrencyShort = (amount: number, currency?: string): string => {
  const symbol = currency === 'USD' ? '$' : '₪';
  const formatted = symbol + amount.toLocaleString('he-IL', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  return '‎' + formatted;
};
